// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconInstallmentPath = 'M17.078 16.018a1.027 1.027 0 0 1-1.139.607l-1.159-.244a7.79 7.79 0 0 0 1.302-4.288c0-3.507-2.34-6.502-5.568-7.458l.671-.894a1.017 1.017 0 0 1 1.262-.297c3.314 1.6 5.455 5.004 5.455 8.67a9.429 9.429 0 0 1-.824 3.904ZM6.322 10.22c.358.42.884.695 1.479.695 1.071 0 1.941-.87 1.941-1.94 0-.792-.479-1.465-1.159-1.768l.603-.803c2.779.427 4.896 2.817 4.896 5.69 0 1.412-.53 2.781-1.462 3.832l-1.743-.367a2 2 0 1 0-3.135-1.644c0 .385.114.742.303 1.047L3.484 14l2.838-3.78Zm6.995-8.576a3.021 3.021 0 0 0-3.735.901L0 15.308l15.535 3.276a3.019 3.019 0 0 0 3.369-1.75c.662-1.47.998-3.059.998-4.72 0-4.429-2.585-8.538-6.585-10.47Z';
var IconInstallment = baseIcon('IconInstallment', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconInstallmentPath
});
export default IconInstallment;
//# sourceMappingURL=index.js.map